import { CaretLeftIcon, CaretRightIcon, ClockCounterClockwiseIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Drawer, IconButton, Text } from '@reveni-io/reveni-ui'

import HistoryContent from './HistoryContent/HistoryContent'
import useHistory from './hooks/useHistory/useHistory'
import * as Styles from './styles'

const HistoryDrawer = ({ show, onClose, title, fieldKeys, fieldKeyPrefix, returnPortalId, objectId, formatEvent }) => {
  const theme = useTheme()
  const { dayGroups, loading, error, hasNext, hasPrev, goNext, goPrev } = useHistory({
    returnPortalId,
    fieldKeys,
    fieldKeyPrefix,
    show,
    objectId,
    formatEvent,
  })

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <Styles.Container>
        <Styles.HeaderContainer>
          <ClockCounterClockwiseIcon size={24} color={theme.colors.text.muted} />
          <Text type="titleM">{title}</Text>
        </Styles.HeaderContainer>
        <HistoryContent error={error} loading={loading} dayGroups={dayGroups} />
        {(hasNext || hasPrev) && !loading && (
          <Styles.PaginationContainer>
            <IconButton variant="text" icon={<CaretLeftIcon size={20} />} onClick={goPrev} disabled={!hasPrev} />
            <IconButton variant="text" icon={<CaretRightIcon size={20} />} onClick={goNext} disabled={!hasNext} />
          </Styles.PaginationContainer>
        )}
      </Styles.Container>
    </Drawer>
  )
}

export default HistoryDrawer
